import styled from 'styled-components'
import { Button } from '@dsny/dsny-component-library'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const largeMobileQuery = createResponsiveBreakpointQuery('largeMobile', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.releasesActionButtonLargeMobile
})

const smallDesktopQuery = createResponsiveBreakpointQuery('smallDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.smallDesktopUp
})

const largeDesktopQuery = createResponsiveBreakpointQuery('largeDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.largeDesktopUp
})

export const ReleaseCardContainer = styled.div`
  padding: 8px;
  border-radius: 5px;
  background-color: #181818;
  max-width: 214px;
  cursor: pointer;

  @media ${smallDesktopQuery} {
    &:hover,
    &[data-context-menu-open='true'] {
      background-color: ${({ theme }) => theme.colors.neutralW20};

      img {
        border-radius: 5px;
        border: 1px solid ${({ theme }) => theme.colors.neutralW20};
        opacity: 0.5;
        background: ${({ theme }) => theme.colors.black0};
      }

      .action_bar {
        visibility: visible;
        opacity: 1;
      }

      .grid_more_actions {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }

  @media ${largeDesktopQuery} {
    padding: 16px;
  }
`

export const ReleaseCardImage = styled.img`
  border-radius: 5px;
  border-width: 2px;
  object-fit: cover;
  border-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export const ReleaseCardTextWrapper = styled.div`
  svg {
    width: 16px;
    height: 16px;
    min-width: 16px;
    margin-right: 4px;
  }

  @media ${mobileQuery} {
    .release_card_date {
      display: none;
    }

    .release_card_artist_row {
      margin-top: 2px !important;
    }

    svg {
      width: 12px;
      height: 12px;
      min-width: 12px;
    }
  }
`

export const ReleaseCardTitle = styled.div`
  width: ${({ $isCompact }) => ($isCompact ? '130px' : '150px')};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: ${({ theme }) => theme.colors.neutralW90};

  @media ${mobileQuery} {
    width: 100%;
    font-size: 12px;
    line-height: 12px;
  }
`

export const ReleaseArtistName = styled.span`
  width: 150px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutralW70};

  @media ${mobileQuery} {
    width: 100%;
    min-width: 0;
    font-size: 12px;
    line-height: 12px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const ActionBarAbsoluteContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-bottom: 10px;
  visibility: hidden;
  opacity: 0;
`

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const ActionButton = styled(Button)`
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.neutralW50 : theme.colors.neutralW100};
  color: ${({ theme }) => theme.colors.neutralW20};
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: none;

  &:hover {
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.colors.neutralW50 : theme.colors.neutralW80};
  }

  @media ${largeMobileQuery} {
    width: 30px;
    height: 30px;
  }
`

export const CardContent = styled.div`
  padding: 16px 0 0;

  @media ${mobileQuery} {
    padding: 8px 0 0;
  }
`

export const GridCardActionsRow = styled.div`
  display: flex;
  width: 100%;
  min-height: 18px;
  margin-top: 12px;
  align-items: center;
  gap: 4px;

  > :first-child {
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
    gap: 4px;
  }

  @media ${mobileQuery} {
    min-height: 12px;
    margin-top: 8px;
  }
`

export const GridMoreActions = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  opacity: ${({ $isAlwaysVisible, $isOpen }) =>
    $isAlwaysVisible || $isOpen ? 1 : 0};
  pointer-events: ${({ $isAlwaysVisible, $isOpen }) =>
    $isAlwaysVisible || $isOpen ? 'auto' : 'none'};
  transition: opacity 0.15s ease;

  &:focus-within {
    opacity: 1;
    pointer-events: auto;
  }

  @media ${mobileQuery} {
    width: 12px;
    height: 12px;
    flex-basis: 12px;
  }
`

export const ReleaseMarketTag = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;

  @media ${mobileQuery} {
    right: 2px;

    > * {
      gap: 2px !important;
      padding: 2px !important;
    }

    svg {
      width: 8px;
      height: 8px;
    }

    span,
    p {
      font-size: 6px !important;
      line-height: 8px !important;
    }
  }
`
